/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Lecture
 * 1 = Ecriture
 * 2 = Modification
 * 3 = Desactivation
 * 4 = Suppression
 * 5 = FermetureTemporaire
 * 6 = Correction
 * 7 = ActiverSurParcsActifs
 * 8 = ModificationNiveauRemplissage
 * 9 = Exclusion
 * 10 = SuppressionSecondeResidence
 * 11 = GenerationCodeConnexion
 * 12 = EcritureBelge
 * 13 = EcritureEtranger
 * 14 = ModificationStatutDTEnDemande
 * 15 = ModificationStatutDTEnCours
 * 16 = ModificationStatutDTLivre
 * 17 = ModificationStatutDTCloture
 * 18 = ModificationStatutDTAnnule
 * 19 = ModificationStatutDTACloturer
 * 20 = ModificationDTEchange
 * 21 = ModificationEnvoiCommande
 * 22 = ModificationValidationCommande
 * 23 = ModificationPreparationCommande
 * 24 = ModificationLivraisonCommande
 * 25 = ValidationIntervention
 * 26 = Bordereau
 * 27 = ModificationCout
 * 28 = ModificationIntervenant
 * 29 = Annulation
 * 30 = PrendreUsageInterne
 * 31 = AjouterUsageInterne
 * 32 = PrendreMaterielVendu
 * 33 = AjouterMaterielVendu
 * 34 = Import
 * 35 = Export
 * 36 = Cloture
 * 37 = AffichageCout
 */
export enum PermissionType {
  Lecture = 0,
  Ecriture = 1,
  Modification = 2,
  Desactivation = 3,
  Suppression = 4,
  FermetureTemporaire = 5,
  Correction = 6,
  ActiverSurParcsActifs = 7,
  ModificationNiveauRemplissage = 8,
  Exclusion = 9,
  SuppressionSecondeResidence = 10,
  GenerationCodeConnexion = 11,
  EcritureBelge = 12,
  EcritureEtranger = 13,
  ModificationStatutDTEnDemande = 14,
  ModificationStatutDTEnCours = 15,
  ModificationStatutDTLivre = 16,
  ModificationStatutDTCloture = 17,
  ModificationStatutDTAnnule = 18,
  ModificationStatutDTACloturer = 19,
  ModificationDTEchange = 20,
  ModificationEnvoiCommande = 21,
  ModificationValidationCommande = 22,
  ModificationPreparationCommande = 23,
  ModificationLivraisonCommande = 24,
  ValidationIntervention = 25,
  Bordereau = 26,
  ModificationCout = 27,
  ModificationIntervenant = 28,
  Annulation = 29,
  PrendreUsageInterne = 30,
  AjouterUsageInterne = 31,
  PrendreMaterielVendu = 32,
  AjouterMaterielVendu = 33,
  Import = 34,
  Export = 35,
  Cloture = 36,
  AffichageCout = 37
}
